export default __webpack_public_path__ + "static/media/triangle.460cddf0.svg";